import moment from 'moment';

export function getTimestampToDate(timestamp, type) {
    switch (type) {
        case 1:
            return moment(new Date(timestamp)).format('MMM DD');
        case 2:
            return moment(new Date(timestamp)).format('YYYY-MM-DD');
        case 3:
            return moment(new Date(timestamp)).format('MMM DD, YYYY');
        case 4:
            return moment(new Date(timestamp)).format('DD-MMM-YYYY');
        case 5:
            return moment(new Date(timestamp)).format('MM-DD-YYYY');
        default:
            return null;
    }
}

export function getNextWeekday(timestamp, weekday) {
    let date = moment(timestamp);
    let week = parseInt(weekday) + 7;
    const day = moment(date).day(week).format('MMMM DD, YYYY');
    return day;
}
